import { http } from "../../../shared/api/http"

/* ===================== TYPES ===================== */

export type ReferralLinkResponse = {
  referral_code: string
}

export type ReferralClickResponse = {
  click_token: string
}

export type ReferralsOverview = {
  total_clicks: number
  total_registered: number
  total_activated: number
  clicks_by_day: { date: string; count: number }[]
  registered_by_day: { date: string; count: number }[]
  activated_by_day: { date: string; count: number }[]
}

export type ReferralsOverviewFilters = {
  from_date?: string
  to_date?: string
}

export type TopReferrerItem = {
  user_id: string
  full_name: string
  email: string
  activated_count: number
}

export type TopReferrersResponse = {
  items: TopReferrerItem[]
}

export type InviteeStatus = "clicked" | "registered" | "activated"

export type ReferralInvitee = {
  referred_user_id: string
  status: InviteeStatus
  clicked_at: string
  registered_at: string | null
  activated_at: string | null
}

export type ReferralUserDetail = {
  referral_code: string
  total_clicks: number
  total_registered: number
  total_activated: number
  invitees: ReferralInvitee[]
}

/* ===================== USER ===================== */

// Получить (или создать) свой реферальный код
export const getReferralLinkApi = () =>
  http.post<ReferralLinkResponse>("/api/referrals/link")

/* ===================== PUBLIC ===================== */

// Клик по реферальной ссылке — вызывается публично на странице /r/:code
export const clickReferralApi = (referralCode: string) =>
  http.post<ReferralClickResponse>("/api/referrals/click", {
    referral_code: referralCode,
  })

/* ===================== ADMIN ===================== */

export const getReferralsOverviewApi = (filters: ReferralsOverviewFilters = {}) =>
  http.get<ReferralsOverview>("/api/admin/referrals/overview", { params: filters })

export const getReferralsTopApi = (limit = 10) =>
  http.get<TopReferrersResponse>("/api/admin/referrals/top", { params: { limit } })

export const getReferralUserDetailApi = (
  userId: string,
  params: { limit?: number; offset?: number } = {}
) =>
  http.get<ReferralUserDetail>(`/api/admin/referrals/users/${userId}`, { params })